import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "column-container" }
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "img-wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text" }

import CardTitle from '@/components/CardTitle.vue'
import { ColumnBoardPage } from '@/api/Models/CommunityHomeData'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'Column',
  props: {
    boardsData: {}
  },
  setup(__props: any) {


const router = useRouter()
const handleJump = (id:string, type: number) => {
  router.push({ path: '/communityDetail', query: { id, type } })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CardTitle, {
      title: _ctx.$t('pc_community_special'),
      path: '/communityColumnPage'
    }, null, 8, ["title"]),
    ( _ctx.boardsData?.records)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boardsData?.records.slice(0,6), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: index,
              onClick: ($event: any) => (handleJump(item.id, item.type))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  class: "img",
                  src: item.coverUrl,
                  alt: ""
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1)
            ], 8, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})